import { useState } from 'react';

interface NavbarProps {
  isFixed: boolean;
}

export default function Navbar({ isFixed }: NavbarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <nav
        className={`w-full z-50 transition-all duration-300 ${
          isFixed ? 'fixed top-0 bg-white shadow-md' : 'absolute top-0 bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img
              src="./thinkpacklogo.png"
              alt="Thinkpack Technologies Logo"
              className="h-15 w-20 object-contain"
            />
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isFixed ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-400'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isFixed ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-400'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('mission')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isFixed ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-400'
              }`}
            >
              Mission & Vision
            </button>
            <button
              onClick={() => scrollToSection('agent')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isFixed ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-400'
              }`}
            >
              Become an Agent
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isFixed ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-400'
              }`}
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('agent')}
            className="hidden md:block bg-orange-500 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-orange-600 transition-colors whitespace-nowrap"
          >
            Get Started
          </button>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden text-2xl ${isFixed ? 'text-gray-900' : 'text-white'}`}
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 bg-black/50 z-40 md:hidden transition-opacity duration-300 ${
          isMobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setIsMobileMenuOpen(false)}
      ></div>

      {/* Mobile Menu */}
      <div
        className={`fixed top-0 right-0 h-full w-80 bg-white z-50 md:hidden transform transition-transform duration-300 ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex items-center justify-between p-6 border-b">
          <span className="text-lg font-bold text-gray-900">Menu</span>
          <button
            onClick={() => setIsMobileMenuOpen(false)}
            className="text-2xl text-gray-900"
          >
            <i className="ri-close-line"></i>
          </button>
        </div>

        <div className="flex flex-col p-6 gap-4">
          <button
            onClick={() => scrollToSection('about')}
            className="text-left text-base font-medium text-gray-700 hover:text-orange-500 transition-colors py-3 border-b whitespace-nowrap"
          >
            About
          </button>
          <button
            onClick={() => scrollToSection('services')}
            className="text-left text-base font-medium text-gray-700 hover:text-orange-500 transition-colors py-3 border-b whitespace-nowrap"
          >
            Services
          </button>
          <button
            onClick={() => scrollToSection('mission')}
            className="text-left text-base font-medium text-gray-700 hover:text-orange-500 transition-colors py-3 border-b whitespace-nowrap"
          >
            Mission & Vision
          </button>
          <button
            onClick={() => scrollToSection('agent')}
            className="text-left text-base font-medium text-gray-700 hover:text-orange-500 transition-colors py-3 border-b whitespace-nowrap"
          >
            Become an Agent
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="text-left text-base font-medium text-gray-700 hover:text-orange-500 transition-colors py-3 border-b whitespace-nowrap"
          >
            Contact
          </button>

          <button
            onClick={() => scrollToSection('agent')}
            className="bg-orange-500 text-white px-6 py-3 rounded-lg text-base font-medium hover:bg-orange-600 transition-colors mt-4 whitespace-nowrap"
          >
            Get Started
          </button>
        </div>
      </div>
    </>
  );
}